import React from 'react';
import MediaQuery from 'react-responsive';
import WorkingAtTotalEnvironment from 'components/organisms/workingAtTE';
import WorkingAtTotalEnvironmentMobile from 'components/organisms/workingAtTEMobile';

const WorkingAtTESection = props => {
  return (
    <div id={'working-at-total-env'}>
      <MediaQuery maxDeviceWidth={575.6}>
        <WorkingAtTotalEnvironmentMobile data={props} />
      </MediaQuery>
      <MediaQuery minDeviceWidth={576}>
        <WorkingAtTotalEnvironment data={props} />
      </MediaQuery>
    </div>
  );
};

export default WorkingAtTESection;
